import { render, staticRenderFns } from "./Reset.vue?vue&type=template&id=3b3a1e64&"
import script from "./Reset.vue?vue&type=script&lang=js&"
export * from "./Reset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports